import { ApiUpsell } from "./interface.api";
import { Upsell } from "@/types";

export const upsellMapper = (api: ApiUpsell): Upsell => {
  return {
    defaultPhotos: api.DefaultPhotos,
    id: api.UplsellPriceId,
    price: api.Price,
  }
}